module.exports = __webpack_public_path__ + "static/media/Flag.0b7bc657.svg";